import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { FormArray, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AutofilliaService } from '../../../../../shared/services/autofillia.service';
import { ApiService } from '../../../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { IAResponseModel } from '../../../../../shared/models/iauser-model';
import { PageEvent } from '@angular/material/paginator';
import { CommonService } from '../../../../../shared/services/common.service';
import { IARepositoryDashboard } from '../../../../../shared/models/IARepositoryDashboard';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';



@Component({
  selector: 'app-repositorycontent',
  templateUrl: './repositorycontent.component.html',
  styleUrl: './repositorycontent.component.css'
})
export class RepositorycontentComponent implements AfterViewInit, OnDestroy {

  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();

  form: FormGroup;
  form1: FormGroup;
  formData: any;
  uploadError: string | null = null;
  documentFile: File | null = null;
  IndustryAssociationId: any;
  uniqueEventId: any;
  EventId: any;
  IAUserId: any;
  //isEditing: boolean = false;
  //interests: any[] = [];
  interventions: any[] = [];
  filteredInterests: any[] = [];
  selectedPairs: {
    interventionId: any;
    interventionName: string,
    interestId: string,
    interestName: string
  }[] = [];
  usr_object!: IAResponseModel;
  name = sessionStorage.getItem('iaUserName');
  //iaUserName = sessionStorage.getItem('iaUserName');
  //IAUserName: string = '';

  iaUserIA = sessionStorage.getItem('iauserid');
  IAUserIA: string = '';

  document: { name: string, file: File | null }[] = [];

  RepositoryDetailsData: any[] = [];
  length: number = 0;
  pageSize: number = 20;
  displayedData: any[] = [];
  reportData: any[] = [];
  pageSizeOptions: number[] = [10, 20, 50, 100];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;
  buttonText: string = 'Save';
  DtoPagination =
    {
      //"IAUserName": this.iaUserName,
      "IAUserId": this.iaUserIA,
      "PageNumber": 1,
      "PageSize": 20,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",
      "SearchCol": ""
    }
    

  //form = new FormGroup({
  //  Intervention: new FormControl('', [Validators.required]),
  //  InterestsId: new FormControl('', [Validators.required]),
  //  documents: new FormArray([
  //    new FormGroup({
  //      documentName: new FormControl('', Validators.required), // For file validation //'', Validators.required
  //      documentFile: new FormControl(null, Validators.required), // For storing the actual file  // null, Validators.required
  //      documentType: new FormControl(null, Validators.required), // For storing the file type //null, Validators.required
  //    }),
  //  ]),
  //});

  dataSource!: MatTableDataSource<IARepositoryDashboard>
  //displayedColumns: string[] = ['Sr.No', 'IAUserName', 'Intervention', 'Interest', 'CreatedDate', 'DocumentName', 'Download']
  displayedColumns: string[] = ['SrNo', 'Name', 'Intervention', 'Interest', 'CreatedDate', 'DocumentName', 'Download'];

  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';

  get f() {
    return this.form.controls;
  }

  constructor(private router: Router, private ia_serv: AutofilliaService, private apiService: ApiService, public commonService: CommonService,
    private toastr: ToastrService, private fb: FormBuilder) {
    this.form = this.fb.group({
      Intervention: ['', Validators.required],
      InterestsId: ['', Validators.required],
      documents: this.fb.array([
        this.fb.group({
          documentFile: [null, Validators.required],
          documentName: [null, Validators.required],
          documentType: [null]
        })
      ])
    });

    this.form1 = new FormGroup({
      searchControl: new FormControl('', [Validators.pattern(this.commonService.searchFilter)])
    })

  }




  async ngOnInit(): Promise<void> {
    this.DtoPagination.PageSize = 20;
    this.DtoPagination.SearchTerm = this.commonService.searchText;
    //await this.loadRepositoryDetails();
    ///this.LoadDetails();
  }

  
  

  //async loadRepositoryDetails(): Promise<void> {
  //  this.apiService.getRequest(API_ENDPOINTS.IA.GETIAREPOSITORYDETAILSBYIAUSERNAME, this.DtoPagination).subscribe(
  //    (result) => {
  //      if (result.status) {
  //        this.length = result['totalRecords'];
  //        this.interventions = result.data.item1;
  //        this.RepositoryDetailsData = result.data.item2;
  //      }
  //    }
  //  );
  //}

  ngAfterViewInit() {
    this.loadRepositoryDetails();
  }


  //async loadRepositoryDetails(): Promise<void> {
  //  // Reset pagination on sort change
  //  this.sort.sortChange.subscribe(() => this.pagination.pageIndex = 0);

  //  // Combine sort changes, search term debounce, and pagination
  //  merge(
  //    this.sort.sortChange,
  //    this.term$.pipe(debounceTime(1100), distinctUntilChanged()),
  //    this.pagination.page
  //  )
  //    .pipe(
  //      filter((searchTerm) => searchTerm != null), // Only process if searchTerm exists
  //      switchMap(() => {
  //        // Reset pagination on new search term
  //        if (this.commonService.searchText) {
  //          this.pagination.pageIndex = 0;
  //        }

  //        // Update DTO for API call
  //        this.DtoPagination.SortColumn = this.sort.active;
  //        this.DtoPagination.SortDirection = this.sort.direction;
  //        this.DtoPagination.SearchCol = this.commonService.searchText;

  //        // Call the API and handle potential errors
  //        return this.apiService
  //          .getRequest(
  //            API_ENDPOINTS.IA.GETIAREPOSITORYDETAILSBYIAUSERNAME,
  //            this.DtoPagination
  //          )
  //          .pipe(catchError(() => of(null))); // Return null on error to prevent crashing
  //      }),
  //      map((result) => {
  //        if (result && result.status) {
  //          this.length = result['totalRecords']; // Update total records for paginator
  //          this.interventions = result.data.item1; // Update interventions data
  //          return result.data.item2; // Return repository details
  //        }
  //        return [];
  //      })
  //    )
  //    .subscribe((repositoryDetails) => {
  //      this.RepositoryDetailsData = repositoryDetails; // Update the repository data
  //      this.adjustPaginator(); // Adjust paginator after data load
  //    });
  //}

  loadRepositoryDetails() {
    if (!this.pagination) return;

    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadDataSubscription.unsubscribe();

    // Reset subscription with a new request
    this.loadDataSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.DtoPagination.SortColumn = this.sort.active;
          this.DtoPagination.SortDirection = this.sort.direction;
          this.DtoPagination.SearchCol = this.commonService.searchText;

          return this.apiService.getRequest(API_ENDPOINTS.IA.GETIAREPOSITORYDETAILSBYIAUSERNAME,this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            this.length = resp['totalRecords'];
            this.interventions = resp.data.item1;
          }
          return resp?.data.item2 || {};
        })
      )
      .subscribe(data => {
        this.RepositoryDetailsData = data;
        this.adjustPaginator();
      });
  }

  ngOnDestroy() {
    this.loadDataSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }


  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }

 

  GetComponent(e: any, action: string) {
    var Interventionid;
    if (action == 'select')
      Interventionid = e.target.value;
    else
      Interventionid = e;

    if (Interventionid != '') {
      const UserId = sessionStorage.getItem("iauserid") || '';
      var getIAComponent = { IAUserId: UserId, Interventionid: Interventionid}
      this.apiService.getRequest(API_ENDPOINTS.IA.GETIAINTEREST, getIAComponent).subscribe({
        next: (response: any) => {
          if (response.status) {
            this.filteredInterests = response.data;            
          } else {
            this.toastr.error('Error fetching Component data', 'Oops...');
          }
        },
        error: (error: any) => {
          this.filteredInterests = [];
          this.toastr.error('Error fetching Component data1', 'Oops...');
        }
      });
    }
  }

  onSubmit() {
    if (this.form.valid) {
      const formData = this.prepareFormData();

      this.apiService.postRequest(API_ENDPOINTS.IA.IASAVEREPOSITORYCONTENT, formData).subscribe(
        res => {
          if (res.status) {
            this.toastr.success(res.message);
            this.clearFileInputs(); // Clear file inputs after submission
            //this.router.navigate(['/viewallonspotregistration/', this.EventId]);
            window.location.reload();
            //this.loadRepositoryDetails();

          } else {
            this.toastr.error(res.message);
          }
        }
      );
    } else {
      this.form.markAllAsTouched();
      return;
    }
  }

  //onReset() {
  //  this.form.reset({
  //    Intervention: '',
  //    InterestsId: '',
  //    documents: []
  //  });
  //}


  // Getter for documents FormArray

  get documents() {
    return this.form.get('documents') as FormArray;
  }

  onAddNewDocument() {
    const newDocumentGroup = this.fb.group({
      documentFile: [null, Validators.required],
      documentName: [null, Validators.required],
      documentType: [null]
    });
    this.documents.push(newDocumentGroup);
  }


  //get documents(): FormArray {
  //  return this.form.get('documents') as FormArray;
  //}



  //onAddNewDocument(): void {
  //  this.documents.push(
  //    new FormGroup({
  //      documentName: new FormControl('', Validators.required),
  //      documentFile: new FormControl(null, Validators.required),
  //      documentType: new FormControl(null, Validators.required),
  //    })
  //  );
  //}


  //onDocumentFileChange(event: Event, index: number): void {

  //  debugger;
  //  const input = event.target as HTMLInputElement;
  //  const file = input.files ? input.files[0] : null;

  //  const validTypes = [
  //    'application/pdf', 'image/jpeg', 'image/png', 'image/jpg',
  //    'application/zip', 'video/mp4', 'video/avi', 'video/mov'
  //  ];
  //  const maxSizeInBytes = 50 * 1024 * 1024; // 50MB

  //  // Get form controls for the current document
  //  const documentGroup = this.documents.at(index);
  //  const documentFileControl = documentGroup.get('documentFile');
  //  const documentNameControl = documentGroup.get('documentName');
  //  const documentTypeControl = documentGroup.get('documentType');

  //  // Reset previous errors
  //  documentFileControl?.setErrors(null);
  //  documentNameControl?.setErrors(null);
  //  documentTypeControl?.setErrors(null);

  //  if (file) {
  //    // Validate file type
  //    if (!validTypes.includes(file.type)) {
  //      documentFileControl?.setErrors({ typeError: true });
  //    } else if (file.size > maxSizeInBytes) {
  //      // Validate file size
  //      documentFileControl?.setErrors({ sizeError: true });
  //    } else {
  //      // If valid, update the form controls with file information
  //      documentFileControl?.setValue(file);
  //      documentTypeControl?.setValue(file.type);
  //      documentNameControl?.setValue(file.name);
  //    }
  //  } else {
  //    // If no file is selected, mark the field as required
  //    documentFileControl?.setErrors({ required: true });
  //  }

  //  // Update the form control validity
  //  documentFileControl?.updateValueAndValidity();
  //  documentNameControl?.updateValueAndValidity();
  //  documentTypeControl?.updateValueAndValidity();
  //}

  onDocumentFileChange(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length) {
      const file = input.files[0];
      //const validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg', 'application/zip'];
      //const maxSizeInMB = 10;
      //const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

      const validTypes = [
        'application/pdf', 'image/jpeg', 'image/png', 'image/jpg',
        'application/zip', 'video/mp4', 'video/avi', 'video/mov'
      ];
      const maxSizeInBytes = 50 * 1024 * 1024; 

      // Get form controls for the current document
      const documentFileControl = this.documents.at(index).get('documentFile');
      const documentNameControl = this.documents.at(index).get('documentName');
      const documentTypeControl = this.documents.at(index).get('documentType');

      // Validate file type
      if (!validTypes.includes(file.type)) {
        documentFileControl?.setValue(null);
        documentFileControl?.setErrors({ typeError: true });
        documentNameControl?.clearValidators();
        documentNameControl?.updateValueAndValidity();
        return;
      }

      // Validate file size
      if (file.size > maxSizeInBytes) {
        documentFileControl?.setValue(null);
        documentFileControl?.setErrors({ sizeError: true });
        documentNameControl?.clearValidators();
        documentNameControl?.updateValueAndValidity();        
        return;
      }

      // If valid, set file name and type
      documentFileControl?.setValue(file);
      documentFileControl?.setErrors(null);

      documentTypeControl?.setValue(file.type);
      documentTypeControl?.setErrors(null);

      documentNameControl?.setValue(file.name);
      documentNameControl?.setValidators([Validators.required]);
      documentNameControl?.updateValueAndValidity();
    } else {
      // Handle case where no file is selected
      const documentFileControl = this.documents.at(index).get('documentFile');
      documentFileControl?.setValue(null);
      documentFileControl?.setErrors({ required: true });

      const documentNameControl = this.documents.at(index).get('documentName');
      documentNameControl?.clearValidators();
      documentNameControl?.updateValueAndValidity();
    }
    //console.log(this.form.valid);
  }


  prepareFormData(): FormData {
    const formData = new FormData();

    // Append each document file
    this.documents.controls.forEach((group: any) => {
      const file = group.get('documentFile')?.value;
      if (file) {
        formData.append('documents[]', file);
      }
    });


    // Extract the documents array from the form (form controls under 'documents' FormArray)
    const documents = this.documents.controls.map((documentFileControl: any) => ({
      name: documentFileControl.get('documentName')?.value,
      file: documentFileControl.get('documentFile')?.value, // This will be the file object (PDF)
      type: documentFileControl.get('documentType')?.value
    }));
    this.document = documents;

    

    this.document.forEach((doc: { name: string, file: File | null }, index: number) => {
      if (doc.file) {
        formData.append(`documents[${index}].documentName`, doc.name);
        formData.append(`documents[${index}].documentFile`, doc.file, doc.file.name);
        formData.append(`documents[${index}].documentType`, doc.file.type);        
      }
    });

    

     //Retrieve iaUserName from session storage and append it to FormData
      const iaUserName = sessionStorage.getItem('iaUserName');
      if (iaUserName) {
        formData.append('iaUserName', iaUserName);
      }


    // Append other fields if needed
    Object.keys(this.form.value).forEach(key => {
      if (key !== 'documents') {
        const value = this.form.get(key)?.value;
        if (value) {
          formData.append(key, value);
        }
      }
    });

    return formData;
  }

  onDownload(filePath: string, fileName: string) {
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    });
  }

  onSearchChange(e: any) {
    this.DtoPagination.SearchTerm = e.target.value;
    this.DtoPagination.PageNumber = 1;
    this.loadRepositoryDetails();
  }
  onPageChange(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    this.loadRepositoryDetails();
  }
  onSearchClick(searchValue: string): void {
    const searchControl = this.form1.get('searchControl');


    if (searchControl?.value && searchValue.trim() !== '') {
      this.DtoPagination.SearchTerm = searchValue.trim();
      this.loadRepositoryDetails();
    } else if (searchValue.trim() === '') {
      searchControl?.markAsTouched();
    } else {
      searchControl?.markAsTouched();
    }
  }

  clearFileInputs(): void {
    // Clear the documents FormArray
    this.form.get('documents')?.value.forEach((_: any, index: number) => {
      const documentGroup = (this.form.get('documents') as FormArray).at(index);

      // Reset documentFile and documentName fields
      documentGroup.get('documentFile')?.setValue(null);
      documentGroup.get('documentFile')?.setErrors(null); // Clear file input errors

      documentGroup.get('documentName')?.setValue('');
      documentGroup.get('documentName')?.setErrors(null); // Clear name input errors
    });

    // Reset the actual file input fields in the DOM
    const fileInputs = document.querySelectorAll('input[type="file"]');
    fileInputs.forEach((fileInput) => {
      (fileInput as HTMLInputElement).value = ''; // Cast to HTMLInputElement and reset value
    });

    // Clear the Intervention and InterestsId fields
    this.form.get('Intervention')?.setValue('');
    this.form.get('Intervention')?.setErrors(null);

    this.form.get('InterestsId')?.setValue('');
    this.form.get('InterestsId')?.setErrors(null);
  }

  removeDocument(index: number) {
    // Removes the form control from the FormArray
    if (this.documents.length > 1) {
      this.documents.removeAt(index);
    }
  }

  onEdit(e: string): void {
    let repositoryData: any[] = []; // Ensure this is typed properly as an array
    const repositoryId = e;

    if (repositoryId !== '') {
      // Pass the repositoryId as a query parameter with the correct name
      this.apiService.getRequest(API_ENDPOINTS.IA.GETIAREPOSITORYID, { getRepositoryDocumentById: repositoryId }).subscribe({
        next: (response: any) => {
          if (response.status) {
            //console.log(response.data);
            repositoryData = response.data; // Assign response data
            //console.log(repositoryData);

            // Update form values
            this.form.patchValue({
              Intervention: repositoryData[0].intervention
            });

            // Call GetComponent inside subscribe after data is available
            this.GetComponent(repositoryData[0].intervention, 'edit');
            this.form.patchValue({
              InterestsId: repositoryData[0].interestId,
            });
            // Bind documents to the FormArray
            this.setDocuments(repositoryData); // Pass the documents correctly here
            // Disable 'Intervention' and 'InterestsId' controls on edit
            this.form.get('Intervention')?.disable();
            this.form.get('InterestsId')?.disable();
            //this.form.markAllAsTouched();  // This will mark all form controls as touched, triggering validation
            //this.form.updateValueAndValidity();  // Revalidate the form and set it as valid if all controls pass
            // Optionally, if you want to ensure the form is valid, you can also manually check and mark it valid
            if (this.form.valid) {
              //console.log('Form is valid');
            } else {
              //console.log('Form is invalid');
            }
          } else {
            this.toastr.error('Error fetching Component data', 'Oops...');
          }
        },
        error: (error: any) => {
          this.filteredInterests = [];
          this.toastr.error('Error fetching Component data', 'Oops...');
        }
      });
    }
  }
  setDocuments(documents: any[]): void {
    const documentsFormArray = this.form.get('documents') as FormArray;
    documentsFormArray.clear(); // Clear existing items
    documents.forEach(doc => {
      documentsFormArray.push(new FormGroup({
        documentName: new FormControl(doc.documentName, Validators.required),
        documentFile: new FormControl(doc.documentFile, Validators.required),
        documentType: new FormControl(doc.documentType, Validators.required),
      }));
    });
    this.buttonText = 'Update'; // Change the button text when editing
    //console.log(documentsFormArray);
  }
  
}
